/*! bxs-vue-ui v4.0.1 */
import { _ as _export, Z as sloppyArrayMethod, M as arrayIteration, L as entryVirtual } from './es.array.join.js';

var $some = arrayIteration.some;


// `Array.prototype.some` method
// https://tc39.github.io/ecma262/#sec-array.prototype.some
_export({ target: 'Array', proto: true, forced: sloppyArrayMethod('some') }, {
  some: function some(callbackfn /* , thisArg */) {
    return $some(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var some = entryVirtual('Array').some;

var ArrayPrototype = Array.prototype;

var some_1 = function (it) {
  var own = it.some;
  return it === ArrayPrototype || (it instanceof Array && own === ArrayPrototype.some) ? some : own;
};

var some$1 = some_1;

var some$2 = some$1;

export { some$2 as s };
